import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';
import _ from 'lodash';

@Component({
  selector: 'app-form-input-date',
  standalone: false,
  templateUrl: './form-input-date.component.html',
  styleUrl: './form-input-date.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputDateComponent),
      multi: true
    }
  ]
})
export class FormInputDateComponent implements OnInit, ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() maxDate: Date | undefined;
  @Input() minDate: Date | undefined;
  @Input() stepMinute: number = 15;
  @Input() timeOnly: boolean;

  public firstDayOfWeek: number = 0;
  public id: string;
  public value: Date | null;
  
  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
    this.value = this.formControl.value ? 
      moment(this.formControl.value).toDate() : (this.timeOnly ? new Date(0, 0, 0, 0, 0, 0) : null);
    // set first day of the week according to user nav lang
    const navLang = navigator.language ? _.first(_.split(navigator.language, '-')) : null;
    this.firstDayOfWeek = navLang === 'es' ? 1 : 0;
    // max hours/minutes
    if(this.maxDate && this.timeOnly) {
      this.maxDate = this.normalizeToToday(new Date());
    }
  }

  private normalizeToToday(date: Date): Date {
    const now = new Date();
    return new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      date.getHours(),
      date.getMinutes(),
      0,
      0
    );
  }

  // value accessor functions
  writeValue(): void {
    this.value = this.formControl.value ? 
      moment(this.formControl.value).toDate() : (this.timeOnly ? new Date(0, 0, 0, 0, 0, 0) : null);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    // max hours/minutes control
    if(this.maxDate && this.timeOnly) {
      if (!$event) return;
      const selected = this.normalizeToToday($event);
      const max = this.normalizeToToday(new Date());
      if (selected > max) {
        this.value = new Date(max); // max allowed
      } else {
        this.value = selected;
      }
    }

    this.onTouch();
    this.onChange($event);
  }
}
